<div class="p-relative h-100 w-100 c-p"
  [class.cursor-disabled]="disabled" [class.cursor-loading]="loading"
  (click)="disabled || loading ? $event.stopPropagation() : {}">
  <div matRipple class="flex-center btn-transition" [class]="panelClass" [class.bkg-grey]="background"
    [ngClass]="'size-' + size + ' color-' + color + ' type-' + type + ' shape-' + shape"
    [class.button-disabled]="disabled" [class.button-loading]="loading" [class.focused]="focused">
    @if (!loading) {
      <img [src]="img" class="btn-transition" alt="" [style.transform]="'rotate('+rotate+'deg)'"/>
    }
    @if (loading) {
      <mat-spinner [diameter]="diameter" class="m-auto"></mat-spinner>
    }
  </div>
  <ng-content></ng-content>
</div>
